import { prescripteursBasePath } from '../pages/Prescripteurs/constants/paths';
import { publishersBasePath } from '../pages/Fournisseurs/constants/paths';
import { achatsBasePath } from '../pages/Achats/constants/paths';

export type supportedModules =
    | 'root'
    | 'accueil'
    | 'debug'
    | 'achats'
    | 'prescripteurs'
    | 'fournisseurs';

export const modulePathResolver = function (module: supportedModules) {
    switch (module) {
        case 'root':
            return '/';
        case 'accueil':
            return '/accueil';
        case 'debug':
            return '/debug';
        case 'achats':
            return `/${achatsBasePath}`;
        case 'prescripteurs':
            return `/${prescripteursBasePath}`;
        case 'fournisseurs':
            return `/${publishersBasePath}`;
        default:
            throw new Error('unimplemented path');
    }
};
